const Joi = require('joi');

export const esiSchema = Joi.object({
    employee_contribution: Joi.number().integer().min(1).required()
        .messages({
            'number.base': 'Employee contribution must be a number',
            'number.integer': 'Employee contribution must be an integer',
            'number.min': 'Employee contribution must be greater than 0',
            'any.required': 'Employee_contribution is a required field'
        }),
    employer_contribution: Joi.number().integer().min(1).required()
        .messages({
            'number.base': 'Employer contribution must be a number',
            'number.integer': 'Employer_contribution must be an integer',
            'number.min': 'Employer_contribution must be greater than 0',
            'any.required': 'Employer_contribution is a required field'
        }),
    decuction_cycle: Joi.string().required()
        .messages({
            'string.base': 'Decuction cycle must be a string',
            'any.required': 'Decuction cycle is a required field'
        }),
    state_id: Joi.number().integer().positive().required()
        .messages({
            'number.base': '"state_id" must be a number',
            'number.integer': '"state_id" must be an integer',
            'number.positive': '"state_id" must be a positive number',
            'any.required': '"state_id" is a required field'
        }),
});


